import React from "react";
import { Grid, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../header";
import BuzzBucksView from "./components/BuzzBucksView";

export default function BuzzBucks() {
  const classes = useStyles();

  return (
    <>
      <Header actions={[]} />
      <Grid
        container
        className={classes.root}
        spacing={0}
      >
        <Grid item xs={12} style={{ width: "100%", padding: 0 }}>
          <Box className={classes.viewContainer}>
            <BuzzBucksView />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    padding: 0,
    margin: 0,
    minHeight: "calc(100vh - 64px)", // Subtract header height
    width: "100%",
  },
  viewContainer: {
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
}));
